export default "__VITE_ASSET__DHVkAlHL__"